import React from "react";
import { Form, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { addBetData,updateBetUser } from "../../../Utility/API";
import { endPoints, PaymentEndpoints } from "../../../constant/Environment";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import { ErrorToast,SuccesToast } from "../../../components/Toast/message";

const Mycorepay = () => {

  const state = useSelector((state)=>state);

  const [rounting, setRounting] = useState("");
  const [account, setAccount] = useState("");
  const [confirmacc, setConfirmacc] = useState("");
  const[isLoading,setIsLoadinig] = useState(false);

  const UpdateCorepay = async (e) => {
    e.preventDefault();

    if(!rounting || !account || ! confirmacc){
      ErrorToast("Please enter all the details.");
      return;
    }

    if(rounting.length != 9){
      ErrorToast("The routing number should be 9 digits.");
      return;
    }

    if(account != confirmacc){
      ErrorToast("The account number did not match.");
      return;
    }

    if(state.auth.user.account.ach_Id == 0){
      ErrorToast("Access Restricted: To unlock the 'My Corepay' module, please complete your first withdrawal. Once you've made your initial transaction, you'll be able to access and manage your account details here.");
     return;
    }

    let url = `${PaymentEndpoints.apiBaseUrl}${PaymentEndpoints.api.UPDATE_COREPAY}`;
    setIsLoadinig(true);
    let data = {
      routingNumber:rounting,
      accountNumber: account,
      idUser: state?.auth?.user?.idUser,
      ach_id : state?.auth?.user?.account?.ach_Id
      // ach_id : 1391
    };
    try {
      let response = await updateBetUser(url, data);
      setIsLoadinig(false);
      // console.log("response",response);
      if (response.status == "success") {
        SuccesToast(response.message);
        setAccount("");
        setConfirmacc("");
        setRounting("");
      } else if (response.status == "failure") {
        ErrorToast(response.message);
      } else {
        ErrorToast(response.message);
      }
    } catch (err) {
      setIsLoadinig(false);
      console.log("err", err);
    }
  };


  const handleNumericInput = (e, setValue) => {
    const value = e.target.value;
  
    // Allow only numeric values
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setValue(value);
    }
  };

  return (
    <div>
      {isLoading && <Loader spinner={false} visible={isLoading} />}
      <div className="container bg-color-about space-bottom">
        <div className="inner-smallspace-about">
          <div className="row">
            <p>
            Update Your Account Details : On this screen, you can update your existing Routing Number and Account Number. Simply enter your new information in the fields provided, confirm your account number, and you're all set!
            </p>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="content-page-design">
                <div className="row mt-2">
                  <Form className="my-form-layout1">
                    <div className="row">
                      <div className="col-md-4">
                        <Form.Group className="mb-3" controlId="phone">
                          <Form.Label className="my-form-label">
                            Routing Number
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Routing Number"
                            value={rounting}
                            maxLength={9}
                            // onChange={(e) => {
                            //   setRounting(e.target.value);
                            // }}
                            onChange={(e) => handleNumericInput(e, setRounting)}
                            required
                          />
                        </Form.Group>
                      </div>

                      <div className="col-md-4">
                        <Form.Group className="mb-3" controlId="phone">
                          <Form.Label className="my-form-label">
                            Account Number
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={account}
                            placeholder="Enter Account No"
                            maxLength={16}
                            // onChange={(e) => {
                            //   setAccount(e.target.value);
                            // }}
                            onChange={(e) => handleNumericInput(e, setAccount)}
                            required
                          />
                        </Form.Group>
                      </div>

                      <div className="col-md-4">
                        <Form.Group className="mb-3" controlId="phone">
                          <Form.Label className="my-form-label">
                            Confirm Account Number
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={confirmacc}
                            placeholder="Confirm Account No"
                            maxLength={16}
                            // onChange={(e) => {
                            //   setConfirmacc(e.target.value);
                            // }}
                            onChange={(e) => handleNumericInput(e, setConfirmacc)}
                            required
                          />
                        </Form.Group>
                      </div>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <Button
                        variant="primary"
                        className="save-btn"
                        // type="submit"
                        style={{ width: "30%" }}
                        onClick={UpdateCorepay}
                      >
                        SAVE
                      </Button>
                    </div>
                  </Form>

                  {/* <div className='btn btn-primary' style={{width:"100%"}}>Activate my Wallet</div> */}

                  <div className="col-lg-1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mycorepay;
